<template>
    <div class="layout-header">
        <div>

            <img class="logo" src="../assets/img/layout/logo.png" alt="" />

        </div>
        <div class="layout-header-r">

            <div class="lang">
                <Popover v-model="langShow" class="lang-box">

                    <div class="lang-popup">
                        <div>
                            <div :class="{ active: $i18n.locale === 'en' }" @click="handleLang('en')">
                                <img src="../assets/img/layout/icon5.png" alt="">
                                <span>{{ $t('layout.en') }}</span>
                            </div>
                            <div :class="{ active: $i18n.locale === 'tc' }" @click="handleLang('tc')">
                                <img src="../assets/img/layout/icon6.png" alt="">
                                <span>{{ $t('layout.tc') }}</span>
                            </div>

                            <div :class="{ active: $i18n.locale === 'zh' }" @click="handleLang('zh')">
                                <img src="../assets/img/layout/icon7.png" alt="">
                                <span>{{ $t('layout.zh') }}</span>
                            </div>

                            <div :class="{ active: $i18n.locale === 'kr' }" @click="handleLang('kr')">
                                <img src="../assets/img/layout/icon8.png" alt="">
                                <span>{{ $t('layout.kr') }}</span>
                            </div>
                            <div :class="{ active: $i18n.locale === 'th' }" @click="handleLang('th')">
                                <img src="../assets/img/layout/icon9.png" alt="">
                                <span>{{ $t('layout.th') }}</span>
                            </div>

                            <div :class="{ active: $i18n.locale === 'vn' }" @click="handleLang('vn')">
                                <img src="../assets/img/layout/icon10.png" alt="">
                                <span>{{ $t('layout.vn') }}</span>
                            </div>
                        </div>
                    </div>
                    <template #reference>
                        <img @click="langShow = true" src="../assets/img/layout/icon1.png" alt="" />
                    </template>
                </Popover>


            </div>

            <div class="layout-header-r-c">
                <img src="../assets/img/layout/icon3.png" alt="">
                <img class="arrow" src="../assets/img/layout/arrow.png" alt="">
            </div>

            <div class="layout-header-r-r">
                {{userName.slice(0,6) +"****" +userName.slice(38,42)}}
            </div>
        </div>
    </div>
</template>
<script>
import { ActionSheet, Popover, Icon, Popup, Field } from 'vant';
import { setLanguage } from "@/utils/cookies";
import { Locale } from 'vant';
import { copyToClipboard } from "@/utils";

import Web3 from 'web3'
let web3
// ethereum.on("accountsChanged",function(accounts){
//     location.reload()
// })

export default {
    name: 'layout-header',
    components: {
        ActionSheet,
        Icon,
        Popup,
        Field,
        Popover
    },
    data() {
        return {
            isLogin: true,
            show: false,
            show1: false,
            check: false,
            menuShow: false,
            langShow: false,
            linkShow: false,
            referenceShow: false,
            walletIcon: '',
            userName: '0x0000000000000000000000000000000000000000',
            actions: [

            ],
            checkItem: '',
            targetChainId: "0x5e87332", // NEX 主网链 ID
        };
    },
    computed: {
        menuItem() {
            return this.menu.find((menuItem) => this.$route.name === menuItem.path);
        },
        menu() {
            return [
                // {
                //     title: this.$t('menu.home'),
                //     icon: require('../assets/img/layout/menus/icon1.png'),
                //     path: 'home'
                // },
                // {
                //     title: this.$t('menu.boarding'),
                //     icon: require('../assets/img/layout/menus/icon2.png'),
                //     path: 'boarding'
                // },
                // {
                //     title: this.$t('menu.staking'),
                //     icon: require('../assets/img/layout/menus/icon2.png'),
                //     path: 'staking'
                // },
                // {
                //     title: this.$t('menu.ranking'),
                //     icon: require('../assets/img/layout/menus/icon2.png'),
                //     path: 'ranking'
                // },
                // {
                //     title: this.$t('menu.pool'),
                //     icon: require('../assets/img/layout/menus/icon2.png'),
                //     path: 'pool'
                // },
                // {
                //     title: this.$t('menu.reincarnation'),
                //     icon: require('../assets/img/layout/menus/icon2.png'),
                //     path: 'reincarnation'
                // },
                // {
                //     title: this.$t('menu.book'),
                //     icon: require('../assets/img/layout/menus/icon2.png'),
                //     path: 'book'
                // },
            ]
        }
    },
    watch: {
        '$route.path'(path) {
            this.menuShow = false;

        }

    },
    methods: {
        toggleSound() {
            this.$store.commit('toggleSound')
        },
        handleLink() {
            if (this.isLogin) {
                this.linkShow = !this.linkShow
            } else {
                this.linkShow = false
            }
        },
        handleMenu(item) {
            this.menuShow = false;
            if (item.path) {
                this.$router.push({
                    name: item.path
                });
            }
            if (item.lang) {
                this.$i18n.locale = item.lang;
                setLanguage(item.lang)
                Locale.use(item.lang, this.$i18n.messages[item.lang])

            }

        },
        handleLang(lang) {
            this.$i18n.locale = lang;
            setLanguage(lang)
            Locale.use(lang, this.$i18n.messages[lang])
            this.langShow = false

        },
        copy(text) {
            copyToClipboard(text)
        },
        userlogin(){
            var that = this;
            if(typeof window.ethereum !='undefined'){
                //console.log('安装了插件')
                web3 = new Web3(window.ethereum);
                ethereum.request({ method: 'eth_requestAccounts' }).then(handleAccountsChanged=>{
                    that.userName = Web3.utils.toChecksumAddress(handleAccountsChanged[0]);
                    that.$store.state.globalAddress = that.userName;
                    that.checkChain()
                })
                .catch((error) => {
                if (error.code === 4001) {
                    console.log('Please connect to MetaMask.');
                } else {
                    console.error("err:"+error);
                }
                });
                console.log('==');
            }
            else{
                console.log('没有安装插件')
            }
        },
        async checkChain() {
            const currentChainId = await window.ethereum.request({
                method: "eth_chainId",
            });
            //console.log("nex_chainId:"+currentChainId)
            if (currentChainId !== this.targetChainId) {
                this.switchToBSC();
            }
        },

        // ✅ 切换到 BSC
        async switchToBSC() {
            try {
                await window.ethereum.request({
                method: "wallet_switchEthereumChain",
                params: [{ chainId: this.targetChainId }],
                });
            } catch (switchError) {
                // ❗ 4902 = 钱包没有该链，需要添加
                if (switchError.code === 4902) {
                this.addBSCNetwork();
                } else {
                console.error("切换网络失败：", switchError);
                }
            }
        },

        // ✅ 添加 BSC 网络
        async addBSCNetwork() {
            try {
                await window.ethereum.request({
                method: "wallet_addEthereumChain",
                params: [
                    {
                    chainId: "0x5e87332",
                    chainName: "Nexus Chain",
                    nativeCurrency: {
                        name: "NEX",
                        symbol: "NEX",
                        decimals: 18,
                    },
                    rpcUrls: ["https://rpc1.nexuschain.ai/"],
                    blockExplorerUrls: ["https://scan.nexuschain.ai/"],
                    },
                ],
                });
            } catch (addError) {
                console.error("添加 NEX 网络失败：", addError);
            }
        },
    },
    mounted(){
        if(this.$store.state.globalAddress =="" ){
            this.userlogin()
        }
        let that = this
        if (window.ethereum) {
            // 先移除旧的监听器，避免重复绑定
            window.ethereum.removeAllListeners("accountsChanged")

            // 绑定一次事件
            window.ethereum.on("accountsChanged", (accounts) => {
                if (accounts.length > 0) {
                //this.currentAccount = accounts[0]
                // 这里你可以选择刷新页面，或者只更新状态
                // location.reload()
                that.userName = Web3.utils.toChecksumAddress(accounts[0]);
                that.$store.state.globalAddress = that.userName;
                
                } 
            })
    }
    }
}
</script>
<style lang="less">
.layout-header {
    display: flex;
    justify-content: space-between;
    position: absolute;
    align-items: center;
    width: 375px;
    height: 38px;
    padding: 8px 16px 0;
    top: 0;
    z-index: 22;


    >div {
        display: flex;

        .logo {
            width: 107px;
            height: 26px;
        }

        .menu {
            width: 24px;
            height: 24px;
        }
    }

    &-r {
        display: flex;


        &-c {
            margin-left: 12px;
            height: 30px;
            width: 56px;
            font-size: 10px;
            font-weight: 500;
            padding: 0 8px;
            font-family: Inter;
            display: flex;
            align-items: center;
            justify-content: space-between;
            background: url('../assets/img/layout/icon2.png') no-repeat center;
            background-size: 100% 100%;

            img {
                width: 20px;
                height: 20px;
            }

            .arrow {
                width: 12px;
                height: 12px;
            }
        }

        .lang {
            margin-left: 16px;
            display: flex;
            align-items: center;
            justify-content: center;

            img {
                width: 30px;
                height: 30px;
            }

        }

        &-r {
            background: url('../assets/img/layout/icon4.png') no-repeat center;
            margin-left: 12px;
            background-size: 100% 100%;
            width: 85px;
            color: #000000;
            font-family: Inter;
            font-size: 10px;
            font-weight: 500;
            height: 30px;
            display: flex;
            align-items: center;
            justify-content: center;
        }


        .menu {}
    }

}

.van-popover--light .van-popover__content {
    background: transparent;
}

.van-popover__arrow {
    display: none;
}
.van-popup.van-popover{
    background: transparent;
}
.lang-popup {
    font-size: 12px;
    width: 180px;
    
    >div {
        padding: 12px  0;
        backdrop-filter: blur(24px);
        // background: rgba(19, 18, 23, 0.5);
        // border: 1px solid linear-gradient(145deg, rgba(255, 255, 255, 0.6) 5%, rgba(255, 255, 255, 0) 55%, rgba(255, 255, 255, 0.6) 95%);
        background: url('../assets/img/layout/lang-bg.png') no-repeat;
        background-size: 100% 100%;
        >div {
            font-size: 12px;
            width: 100%;
            position: relative;
            display: flex;
            align-items: center;
            padding: 8px 16px;
            white-space: nowrap;
            display: flex;
            color: #FFFFFF;

            &.active {
                color: #05B9D0;

                &::before {
                    content: ' ';
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    right: 16px;
                    top: 50%;
                    transform: translateY(-50%);
                    background: url('../assets/img/layout/icon11.png') no-repeat;
                    background-size: 100%;
                    height: 100%;
                    width: 20px;
                    height: 20px;
                    display: block;
                }


            }

            >img {
                width: 20px;
                height: 20px;
            }

            >span {
                margin-left: 8px;
                position: relative;
                z-index: 11;
            }
        }
    }
}
</style>